import React, { FC } from 'react'

import { useHeader } from 'modulesCommon/serviceHooks'
import { ProductMatchNotificationsModal } from 'modulesCommon/Notifications/containers'

import { useShowAlert } from 'shared/hooks'

import { SBXHeader } from '../components/Header/SBXHeader'

const HeaderContainer: FC = () => {
  useShowAlert()
  const { isLoading, activeArtist } = useHeader()

  return (
    <>
      <SBXHeader
        isLoading={isLoading}
        activeArtist={activeArtist}
      />
      <ProductMatchNotificationsModal />
    </>
  )
}

export default HeaderContainer
